import * as React from 'react';
import * as styles from './styles.css';

const ExpertImg = require('../../assets/expert.png');

import { InlineText1 } from '@cian/ui-kit/typography';

export interface IExpertViewProps {
  text: string;
  url: string;
  onClick?(): void;
}

export function ExpertView({ text, url, onClick }: IExpertViewProps) {
  return (
    <div className={styles['container']}>
      <img className={styles['expert-img']} src={ExpertImg} alt="эксперт" />
      <div className={styles['text']}>
        <InlineText1>{text}</InlineText1>
      </div>
      <a href={url} onClick={onClick} className={styles['link']}>
        <InlineText1 color="primary_100">Узнать советы аналитиков Циан</InlineText1>
      </a>
    </div>
  );
}
